<template>
<div v-bind:class="{'main-container':showFeedbackForm,'off-main-container':!showFeedbackForm}"> 
    <star-rating v-model="rating" :star-size="25" increment="0.5" class="mb-3"></star-rating>
    <!-- <input type="text" class="text-area" placeholder="Your Review..."> -->
    <textarea name="" id="" cols="30" rows="10" class="text-area"></textarea>
    <div class="button-container">
     <span class="feedback-button">Submit</span>
      <span class="feedback-button" @click="hideFeedbackForm">Maybe later</span>
    </div>
</div>

</template>

<script>
import StarRating from 'vue-star-rating';






export default {
  components: {
 StarRating,
 
 

  },
  data() {
    return {
      showFeedbackForm: true,
      rating: 0,
      review: ''
    };
  },
  methods: {
    submitFeedback() {
      // Here you can perform actions like sending feedback to a server
      // For this example, we'll just log the feedback
      console.log('Rating:', this.rating);
      console.log('Review:', this.review);
      this.rating = 0;
      this.review = '';
      this.showFeedbackForm = false;
    },
    hideFeedbackForm() {
      this.showFeedbackForm = false;
    }
  }
};
</script>



<style scoped>
.main-container{
  background: #1a1625;
  display: block;
  visibility: visible;
  border-width: 1px;
  width: 25vw;
  height: 15vh;
  box-shadow: 2px 0 5px rgba(0.5, 0.5, 0, 0.1);
  padding: 2%;
  position: fixed;
  right: 1%;
  bottom:1%;
}

.off-main-container{
  visibility: hidden;
}

.text-area{
  width: 25vw;
  height: 8vh;
  margin-bottom: 2%;
  background: #2f2b3a ;
  resize: none;
  color: aliceblue;
}

.feedback-button{
 margin: 5%;
 cursor: pointer;
 font-size:1.1vw
}

@media only screen and (max-width: 800px){
  .main-container{
    visibility: hidden;
    width: none;
    height: none;
  }
}
</style>
